import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=fe15a502&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=fe15a502&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe15a502",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fe15a502')) {
      api.createRecord('fe15a502', component.options)
    } else {
      api.reload('fe15a502', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=fe15a502&scoped=true&", function () {
      api.rerender('fe15a502', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8QK7xqFByOTng/JS/teamMember.vue"
export default component.exports